import React from 'react';
import BaseConfirmationPopup from '../BaseConfirmationPopup';
import s from './ConfirmationPopup.scss';
import Flex from '../../Flex';
var ConfirmationPopup = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, text = _a.text, icon = _a.icon, onCancel = _a.onCancel, onConfirm = _a.onConfirm, cancelBtnLabel = _a.cancelBtnLabel, confirmBtnLabel = _a.confirmBtnLabel, _b = _a.confirmBtnType, confirmBtnType = _b === void 0 ? 'default' : _b;
    return (React.createElement(BaseConfirmationPopup, { isOpen: isOpen, title: title, cancelButtonLabel: cancelBtnLabel, confirmButtonLabel: confirmBtnLabel, confirmButtonType: confirmBtnType, onDone: onConfirm, onCancel: onCancel },
        React.createElement(Flex, { alignItems: "center" },
            icon && React.createElement("div", { className: s['icon-wrapper'] }, icon),
            React.createElement("p", null, text))));
};
ConfirmationPopup.displayName = 'ConfirmationPopup';
export default ConfirmationPopup;
//# sourceMappingURL=ConfirmationPopup.js.map